<template>
    <div class="panel panel-primary">
        <div class="panel-heading">
            Training Set Details
        </div>
        <div class="panel-body">
            <div class="form">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <div class="form-group">
                            <input v-model="trainingSet.training_set_name" placeholder="Name" class="form-control"/>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                            <input v-model="trainingSet.distance" placeholder="Distance" class="form-control"/>
                        </div>
                    </div>
                        <div class="col-xs-12 col-sm-6 col-md-3">
                            <div class="form-group">
                                <input v-model="trainingSet.type" placeholder="Type" class="form-control"/>
                            </div>
                        </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <textarea v-model="trainingSet.details" v-on:keydown.tab.stop.prevent="handleTabKey" class="form-control" rows="15"></textarea>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-right">
                    <button v-on:click="saveTrainingSet" class="btn btn-success">Save</button>
                    <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>

	export default {
		data: function () {
			return {
			    trainingSetId: null,
                trainingSet: {
                    training_set_name: null,
                    training_set: null,
                    distance: null,
                    type: null,
                    time: null,
                    intensity: null
                },
            }
		},
		mounted() {
				console.log('Training Set component mounted.');
		},
		methods: {
            setTrainingSetData(training_set_id, training_set) {
                // Load the training set and populate the object
                this.debug('setTrainingSetData');
                this.trainingSetId = training_set_id;
                this.trainingSet = {
                    training_set_name: training_set.training_set_name,
                    details: training_set.details,
                    distance: training_set.distance,
                    type: training_set.type,
                    time: training_set.time,
                    intensity: training_set.intensity
                };
            },
            loadEmptyTrainingSet() {
                this.debug('loadEmptyTrainingSet()');
                this.trainingSet = {
                    training_set_name: null,
                    details: null,
                    distance: null,
                    type: null,
                    time: null,
                    intensity: null
                };
                this.trainingSetId = null;
            },
            saveTrainingSet() {
                this.debug('saveTrainingSet()');

                // Save the training set to the server - by default we create a new set but change the request if it's an update
                let requestUrl = '/api/v1/training_set';
                let requestMethod = 'post';
                if (this.trainingSetId != null) {
                    requestUrl = `/api/v1/training_set/${this.trainingSetId}`;
                    requestMethod='put';
                }
                axios({
                    method: requestMethod,
                    url: requestUrl,
                    data: {
                        training_set: this.trainingSet
                    }
                }).then((response) => {
                    // this.loadingInstance.close();
                    this.debug(response.data);
                    this.$emit('training-set-updated');
                }).catch((error) => {
                    // this.loadingInstance.close();
                    this.$message({message: 'There was a problem saving the training set.', type: 'error'});
                });
            },
            handleTabKey(event) {
                // console.log(event.target);
                // console.log(event.target.value);
                // console.log(event.target.selectionStart);
                // console.log(event.target.selectionEnd);

                // get caret position/selection
                var val = event.target.value,
                    start = event.target.selectionStart,
                    end = event.target.selectionEnd;

                // set textarea value to: text before caret + tab + text after caret
                event.target.value = val.substring(0, start) + '\t' + val.substring(end);

                // put caret at right position again
                event.target.selectionStart = event.target.selectionEnd = start + 1;

                // prevent the focus lose
                return false;
            },
            debug(message) {
                console.log('TrainingSetList: ' + message);
            }
        }
	}
</script>
